import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
	const navigate = useNavigate();
	return (
		<div>
			<div style={{ height: '90vh' }} className="d-flex flex-column justify-items-center justify-content-center">
				<h2 className="text-center">Sorry, Page Not Found</h2>
				<button
					className="d-flex"
					style={{ width: 'fit-content', alignSelf: 'center' }}
					onClick={() => navigate('/terminal')}
				>
					Return Home
				</button>
			</div>
		</div>
	);
};

export default NotFound;
